module.exports = function getResource(label, vars = []) {
    const resources = { buyWith: 'Buy with' };

    return resources[label];
};
